var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarUnlock(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon / unfixed"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic-permits-ead8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "unlocked-icon",
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 8H18C19.1 8 20 8.9 20 10V20C20 21.1 19.1 22 18 22H6C4.9 22 4 21.1 4 20V10C4 8.9 4.9 8 6 8H15.1V6C15.1 4.29 13.71 2.9 12 2.9C10.5066 2.9 9.25731 3.96013 8.96475 5.36771L7.10016 5C7.56384 2.71865 9.58243 1 12 1C14.76 1 17 3.24 17 6V8ZM12 17C13.1 17 14 16.1 14 15C14 13.9 13.1 13 12 13C10.9 13 10 13.9 10 15C10 16.1 10.9 17 12 17ZM6 20H18V10H6V20Z",
    fill: "#A4A8B1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarUnlock);
export default __webpack_public_path__ + "static/media/sidebar_unlock.7785ad6e6d265f4c13773d18a4376297.svg";
export { ForwardRef as ReactComponent };